import React, { useState, useEffect } from "react";

import SingleDate from "./SingleDateSelection";
import MonthDate from "./MonthDateSelection";
import DateInput2 from "./DateInputx";
import DateTimeSelection from "./DateTimeSelection";
type Props = {
  name: string;
  title?: string;
  placeHolder?: string;
  handleChangeEvent: (value: string, name: string) => void;
  value?: string | null;
  isDisabled?: boolean;
  customClass?: string;
  customLabelClass?: string;
  dropDownClass?:string
  min?: string;
  max?: string;
  isRequired?: boolean;
  inputType?: string;
  field?: any;
  dateInputProps?: any;
  onClickAction?:any
  footerOptions?:{
    activatedToday?:boolean
    activatedClear?:boolean
    onClear?:any
    onReset?:any
    hasCustomFooter?:boolean
    customFooter?:any
  }
  
};
const DateFormGenerator = (props:Props & {openModel:boolean,setOpenModel:any}) => {
  const {name,title,min,max,customClass,customLabelClass,placeHolder,handleChangeEvent,inputType,value,isRequired,isDisabled,dateInputProps,openModel,setOpenModel,footerOptions} = props
  switch (inputType) {
    case "date":
        return <SingleDate {...props} field={dateInputProps?.field || {}} openModel={openModel} setOpenModel={setOpenModel} />
    case "month":
        return <MonthDate {...props} field={dateInputProps?.field || {}} />
    case "datetime-local":
         return <DateTimeSelection {...props} field={dateInputProps?.field || {}} openModel={openModel} setOpenModel={setOpenModel} />
    default:
        return <SingleDate {...props} field={dateInputProps?.field || {}} openModel={openModel} setOpenModel={setOpenModel} />
  }
}
function DateInput(props: Props) {
  const {
  name,
  title,
  min,
  max,
  customClass,
  customLabelClass,
  placeHolder = "",
  handleChangeEvent,
  inputType = "date",
  value = null,
  isRequired = true,
  isDisabled = false,
  dateInputProps,
  dropDownClass,
  onClickAction,
  footerOptions,
  
}=props
  const [openModel, setOpenModel] = useState<boolean>(false);
  
  if(inputType === 'week' ){
    return <DateInput2 {...props}/>
  }
  return (
    <div className="relative" >
       <DateFormGenerator name={name} title={title} min={min} max={max} customClass={customClass} customLabelClass={customLabelClass} placeHolder={placeHolder} handleChangeEvent={handleChangeEvent} inputType={inputType} value={value} isRequired={isRequired} isDisabled={isDisabled} dateInputProps={dateInputProps} openModel={openModel} setOpenModel={setOpenModel} dropDownClass={dropDownClass} onClickAction={onClickAction} footerOptions={footerOptions}  />
    </div>
  );
}
export default DateInput;
